import { oz } from '@weft/utils';
import { segregated } from '../../utils/segregated';
import { ProductSchema } from '../product';
import { PromotionSchema } from '../promotion';
import { NewPlanSchema } from './new-plan-schema';

export const PlanSchema = segregated(NewPlanSchema)
  .extend({
    products: oz.array(ProductSchema),
    promotions: oz.array(PromotionSchema),
    revision: oz.number(),
  })
  .openapi('Plan');

export type Plan = oz.infer<typeof PlanSchema>;